import { NavigationStore } from '~/features/store/navigation/business/useNavigationStore';

export default defineNuxtPlugin((nuxtApp) => {
  const navigation = NavigationStore
  
  const router = nuxtApp.$router as any
  
  router.beforeEach((to: any, from: any, next: any) => {
    if (!from.name && document.referrer) {
      navigation.setPrevious(document.referrer);
    } else if (from.fullPath && from.fullPath !== '/') {
      navigation.setPrevious(from.fullPath);
    }
    next()
  })
})
